<template>
	<div class="wrapper">
		<headerTag />
			<div v-show="play==1">
				<p class="userIn1" style="margin-top: 6.15rem;">
					<input type="number" placeholder="手机号" autocomplete="off" v-model="umobile" onkeyup="this.value=this.value.replace(/[^\d\.]/g,'')" oninput="if(value.length>11)value=value.slice(0,11)" />
					<img src="../../assets/images/user/phone1.png" alt="" />
				</p>
				<div>
					<p class="userIn1" style="margin-bottom: 0; margin-right: 0; width: 60%; float: left;">
						<input type="text" placeholder="图形验证码" maxlength="4" autocomplete="off" style="width: 100%;" v-model="code" onKeyUp="value=value.replace(/[\W]/g,'')" />
					</p>
					<canvas id="canvas" class="codeImg" @click="imgCode" style="width: 25%;"></canvas>
				</div>
				<button class="userBtn1" @click="tipsOne">下一步</button>
			</div>
			<div v-show="play==2">
				<p class="phoneNum">已验证手机：{{phoneNum}},已注册可使用</p>
				<p class="userIn1" style="margin-bottom: 0;">
					<input type="text" placeholder="验证码" style="width: 60%;" autocomplete="off" maxlength="6" v-model="smscode" onkeyup="this.value=this.value.replace(/[^\d\.]/g,'')" />
					<button class="getCode" @click="getcodeFuc" id="getCode">{{getCodeNum}}</button>
				</p>
				<button class="userBtn1" @click="tipsTwo">下一步</button>
			</div>
			<div v-show="play==3">
				<p class="userIn1" style="margin-top: 6.15rem;">
					<input type="password" placeholder="新密码" autocomplete="off" v-model="newPassword" maxlength="20" />
					<img src="../../assets/images/user/password1.png" alt="" class="passwordImg" />
				</p>
				<p class="userIn1" style="margin-bottom: 0;">
					<input type="password" placeholder="确认新密码" autocomplete="off" v-model="confirmPassword" maxlength="20" />
					<img src="../../assets/images/user/password1.png" alt="" class="passwordImg" />
				</p>
				<button class="userBtn1" @click="tipsThree">下一步</button>
			</div>
			<div v-show="play==4">
				<p class="donePass" style="margin-top: 6.15rem;">
					<img src="../../assets/images/user/success.png" alt="" />
					<span>恭喜！新密码设置成功~</span>
				</p>
				<router-link :to="{ name:'loginPage' }"><button class="userBtn1">登录</button></router-link>
				<router-link :to="{ name:'homePage' }"><button class="userBtn1 userBtn1-color1" style="margin-top: 0;">返回首页</button></router-link>
			</div>
	</div>

</template>

<script>
   
    import "../../assets/css/user.scss"
    import headerTag from '@/components/headerTag/headerTag.vue'
	import {VidateUtil} from '../../assets/js/validate.js'
	import {sendSms,phoneSeconds} from '../../assets/js/smsUtil.js'
	import {Decrypt,Encrypt} from '../../assets/js/aes/cryptoUtil.js'
	import { Dialog,Toast } from 'vant'
	
	
	export default {
		name: 'findPassword',
		props: {
        
		},
		components: {
			headerTag,
			VidateUtil,
			sendSms,
			phoneSeconds,
			
		},
		data(){
		  return {
		    play: '1',
			umobile:'',
			code:'',
			getCodeNum:'获取验证码',//获取短信验证码
			smscode:'',
			phoneNum:'',
			newPassword:'',
			confirmPassword:'',
		  }
		},
		methods:{
			phoneNone(){
				this.phoneNum= this.umobile.substr(0,3)+"****"+this.umobile.substr(7);
			},
			getcodeFuc(){//获取短信验证码
			
				let mobile=Encrypt(this.umobile);
				let _this=this;
				sendSms(2,mobile,function(data){
					if(data.code == 1000){
						//短信发送成功，弹出提示框
						_this.$toast("已发送验证码到您的手机，请注意查收");
						phoneSeconds(); //倒计时
						
					}else{
						_this.$message.error({message: data.message});
					}
					
				},(errorback)=>{
					//回调错误信息
					_this.$message.error({message: errorback});
				});
				
			},
			
			imgCode(){//获取图形验证码
				this.axios({
				    method: 'POST',
				    url:'/sendCode',
				}).then((res)=>{
					let data = res.data;
					VidateUtil.drawPic(data);
				}).catch((err)=>{
				    this.$message.error({message: '网络异常，请稍后重试'});
				})
			},
			tipsOne(){
				if (this.umobile == "" || this.umobile == null) {
				       this.$message.error({message: '手机号不能为空'});
				       return;
				}else if(!/^1[3456789]\d{9}$/.test(this.umobile)) {
						this.$message.error({message: '手机号输入不正确'});
						return;
				}else if (this.code == "" || this.code == null) {
				        this.$message.error({message: '验证码不能为空'});
				        return;
				}else if (this.code.length != 4) {
				        this.$message.error({message: '验证码输入不正确'});
						this.code='';
				        return;
				 }else{
					 this.axios({
				     method:'post',
				     url:'/user/forgetPwdTheMobile',
				     params:{
				        umobile: this.umobile,
						code:this.code,
				     }
				   }).then(res=>{
						this.imgCode();
				     	let data = res.data.code;
						if(data==1000){
							this.play=2
						}else{
							this.code='';
							this.$message.error({message: res.data.message});
						}
				
				   }).catch(err=>{
				   		this.code='';
				   		this.imgCode();
						this.$message.error({message: '网络异常，请稍后重试'});
				   });
				   
				   this.phoneNone();
				 }
							
			}, 
			tipsTwo(){
				if (this.smscode == "" || this.smscode == null) {
				        this.$message.error({message: '验证码不能为空'});
				        return;
				}else if (this.smscode.length != 6) {
				        this.$message.error({message: '验证码输入不正确'});
				        return;
				 }else{
					this.axios({
					  method:'post',
					  url:'/user/forgetPwdAuth',
					  params:{
					     umobile: this.umobile,
						 smscode:this.smscode,
					  }
					}).then(res=>{
					  let data = res.data.code;
					  if(data==1000){
						  this.play=3
					  }else{
						  this.$message.error({message: res.data.message});
					  }
									
					}).catch(err=>{
						 this.$message.error({message: '网络异常，请稍后重试'});
					}); 
				 }
			},
			tipsThree(){
				//新密码
				if (this.newPassword == "" || this.newPassword == null) {
					this.$message.error({message: '新密码不能为空'});
					return;
				}
				if (this.newPassword.length > 20 || this.newPassword.length < 8) {
					this.$message.error({message: '密码长度限8~20个字数且不支持空格'});
					return;
				}
				if(!VidateUtil.checkPassword(this.newPassword)){
					this.$message.error({message: '密码长度限8~20个字数且不支持空格'});
					return;
				}
				//确认密码
				if (this.confirmPassword == "" || this.confirmPassword == null) {
					this.$message.error({message: '确认密码不能为空'});
					return;
				}
				if (this.confirmPassword.length > 20 || this.confirmPassword.length < 8) {
					this.$message.error({message: '密码长度限8~20个字数且不支持空格'});
					return;
				}
				if(!VidateUtil.checkPassword(this.confirmPassword)){
					this.$message.error({message: '密码长度限8~20个字数且不支持空格'});
					return;
				}
				if(this.confirmPassword != this.newPassword){
					this.$message.error({message: '确认密码与新密码不一致'});
					return;
				}
				this.axios({
					method: 'POST',
					url:'/user/forgetPwd',
					params:{
						umobile:this.umobile,
						newPassword:this.newPassword,
						confirmPassword:this.confirmPassword
					},
				}).then((res)=>{
						if(res.data.code==1000){
							 this.play=4
						}else if(res.data.code==1002){
							this.$message.error({message: res.data.message});
						}else{
							this.$message.error({message: '网络异常，请稍后重试'});
						}
				}).catch((err)=>{
					this.$message.error({message: '网络异常，请稍后重试'});
				})
			},
		},
		created() {
			this.imgCode();
		}
	}

</script>